import dayjs from 'dayjs';
import { MemberChangeLog } from 'src/modules/member/models/memberChangeLog';

export const groupLogsByDate = (logs: MemberChangeLog[]) => {
  const groupedLogs: { [key: string]: MemberChangeLog[] } = {};

  logs.forEach((log) => {
    const logDate = dayjs(log.date);
    let key: string;

    if (logDate.isSame(dayjs(), 'day')) {
      key = 'Idag';
    } else if (logDate.isSame(dayjs().subtract(1, 'day'), 'day')) {
      key = 'Igår';
    } else {
      key = logDate.format('D MMM');
    }

    if (!groupedLogs[key]) {
      groupedLogs[key] = [];
    }

    groupedLogs[key].push(log);
  });

  return groupedLogs;
};
